<div class="mx-auto max-w-6xl">
  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Bulk-Import</h1>
    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
      Aktenzeichen mit dem Barcode-Scanner erfassen. Jeder Scan legt einen Entwurf mit den
      Standardwerten an &mdash; die Details k&ouml;nnen sp&auml;ter erg&auml;nzt werden.
    </p>
  </div>

  <!-- Type toggle -->
  <div class="mb-4 flex gap-2">
    <button
      type="button"
      (click)="selectType(0)"
      [ngClass]="bom === 0 ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 border border-gray-300'"
      class="rounded-lg px-4 py-2 text-sm font-medium transition hover:opacity-90">
      Anzeige
    </button>
    <button
      type="button"
      (click)="selectType(1)"
      [ngClass]="bom === 1 ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 border border-gray-300'"
      class="rounded-lg px-4 py-2 text-sm font-medium transition hover:opacity-90">
      BOM
    </button>
  </div>

  <!-- Scan input -->
  <div class="mb-6 rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
    <label class="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
      Aktenzeichen scannen ({{ typeLabel }})
    </label>
    <div class="flex gap-2">
      <input
        #scanInput
        type="text"
        [(ngModel)]="scanValue"
        (keyup.enter)="onScanEnter()"
        [disabled]="creating"
        autocomplete="off"
        placeholder="Barcode scannen oder Aktenzeichen eingeben + Enter"
        class="flex-1 rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
      <button
        type="button"
        (click)="onScanEnter()"
        [disabled]="creating"
        class="rounded-lg bg-blue-600 px-5 py-2 text-sm font-medium text-white transition hover:bg-blue-700 disabled:opacity-50">
        {{ creating ? 'Erfasse...' : 'Erfassen' }}
      </button>
    </div>
    <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
      Standardwerte: Strafe {{ defaults.strafe }} &euro; &middot; Land {{ defaults.kzland }} &middot; Bezirk
      {{ defaults.kzbezirk || '-' }} &middot; Zone {{ defaults.zone }} &middot; Fahrzeugart {{ defaults.fahrzeugart }}
    </p>
  </div>

  <!-- Captured rows -->
  <div class="rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800">
    <div class="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700">
      <h2 class="text-sm font-semibold text-gray-900 dark:text-white">Heute erfasst</h2>
      <span class="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700">{{ rows.length }}</span>
    </div>

    <div class="overflow-x-auto">
      <table class="w-full text-left text-sm text-gray-700 dark:text-gray-300">
        <thead class="bg-gray-50 text-xs uppercase text-gray-500 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th class="px-3 py-2">Aktenzeichen</th>
            <th class="px-3 py-2">Typ</th>
            <th class="px-3 py-2">Kennzeichen</th>
            <th class="px-3 py-2">Stra&szlig;e</th>
            <th class="px-3 py-2">Strafe</th>
            <th class="px-3 py-2">Zeit</th>
            <th class="px-3 py-2 text-right">Aktionen</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="rows.length === 0">
            <td colspan="7" class="px-3 py-6 text-center text-gray-400">Noch keine Eintr&auml;ge erfasst.</td>
          </tr>

          <ng-container *ngFor="let row of rows">
            <tr class="border-b border-gray-100 dark:border-gray-700">
              <td class="px-3 py-2 font-medium text-gray-900 dark:text-white">{{ row.aktenzeichen }}</td>
              <td class="px-3 py-2">
                <span
                  [ngClass]="row.bom === 1 ? 'bg-amber-100 text-amber-800' : 'bg-sky-100 text-sky-800'"
                  class="rounded px-2 py-0.5 text-xs font-medium">
                  {{ row.bom === 1 ? 'BOM' : 'Anzeige' }}
                </span>
              </td>
              <td class="px-3 py-2">
                <div class="flex gap-1">
                  <input
                    type="text"
                    [(ngModel)]="row.kzland"
                    class="w-12 rounded border border-gray-300 px-1.5 py-1 text-xs dark:border-gray-600 dark:bg-gray-700" />
                  <input
                    type="text"
                    [(ngModel)]="row.kzbezirk"
                    class="w-14 rounded border border-gray-300 px-1.5 py-1 text-xs dark:border-gray-600 dark:bg-gray-700" />
                  <input
                    type="text"
                    [(ngModel)]="row.kznummer"
                    placeholder="Nummer"
                    class="w-24 rounded border border-gray-300 px-1.5 py-1 text-xs dark:border-gray-600 dark:bg-gray-700" />
                </div>
              </td>
              <td class="px-3 py-2">
                <div class="flex gap-1">
                  <input
                    type="text"
                    [(ngModel)]="row.street"
                    placeholder="Stra&szlig;e"
                    list="bulk-streets"
                    class="w-40 rounded border border-gray-300 px-1.5 py-1 text-xs dark:border-gray-600 dark:bg-gray-700" />
                  <input
                    type="text"
                    [(ngModel)]="row.streetnbr"
                    placeholder="Nr."
                    class="w-14 rounded border border-gray-300 px-1.5 py-1 text-xs dark:border-gray-600 dark:bg-gray-700" />
                </div>
              </td>
              <td class="px-3 py-2">
                <input
                  type="number"
                  [(ngModel)]="row.strafe"
                  class="w-16 rounded border border-gray-300 px-1.5 py-1 text-xs dark:border-gray-600 dark:bg-gray-700" />
              </td>
              <td class="px-3 py-2 whitespace-nowrap text-xs text-gray-500">{{ row.createtime }}</td>
              <td class="px-3 py-2">
                <div class="flex justify-end gap-1">
                  <button
                    type="button"
                    (click)="saveRow(row)"
                    title="Speichern"
                    class="rounded bg-green-600 px-2 py-1 text-xs font-medium text-white hover:bg-green-700">
                    Speichern
                  </button>
                  <button
                    type="button"
                    (click)="toggleUpload(row)"
                    title="Foto hinzuf&uuml;gen"
                    class="rounded bg-gray-200 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-300">
                    Foto
                  </button>
                  <button
                    type="button"
                    (click)="openInEditor(row)"
                    title="Im Editor &ouml;ffnen"
                    class="rounded bg-gray-200 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-300">
                    Bearbeiten
                  </button>
                </div>
              </td>
            </tr>

            <!-- photo upload panel -->
            <tr *ngIf="activeUploadAkt === row.aktenzeichen">
              <td colspan="7" class="bg-gray-50 px-4 py-3 dark:bg-gray-700">
                <p class="mb-2 text-xs text-gray-500">
                  Bilder f&uuml;r Aktenzeichen <strong>{{ row.aktenzeichen }}</strong> hochladen.
                </p>
                <file-pond [options]="pondOptions"></file-pond>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <datalist id="bulk-streets">
    <option *ngFor="let s of stammdaten.streets" [value]="s.bezeichnung"></option>
  </datalist>
</div>
